import { useState } from "react";
import type { PropsWithChildren, ReactNode } from "react";
import { Dialog, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router";
import type { To } from "react-router";
import { TransitionSlideLeft, TransitionSlideUp } from "utils/animations";

interface ModalPageTemplateProps extends PropsWithChildren {
  returnPath?: string;
}

function ModalPageTemplate({ children, returnPath }: Readonly<ModalPageTemplateProps>): ReactNode {
  const [open, setOpen] = useState(true);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  const navigate = useNavigate();
  function handleDialogClose(): void {
    setOpen(false);
    setTimeout(() => {
      navigate((returnPath ?? -1) as To);
    }, 250);
  }

  return (
    <Dialog
      fullScreen
      sx={{ left: { xs: 0, md: "10%", lg: "20%" } }}
      onClose={handleDialogClose}
      slots={{ transition: isSmallScreen ? TransitionSlideUp : TransitionSlideLeft }}
      open={open}>
      {children}
    </Dialog>
  );
}

export default ModalPageTemplate;
